import { login, logout } from '../Slice/authSlice';

export const loginUser = (user, token) => (dispatch) => {
  dispatch(login({ user, token }));
};

export const logoutUser = () => (dispatch) => {
  dispatch(logout());
};
